import React, {Fragment} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {LoadingBar, PageLoader} from "../../components/Loader";
import history from "../../../libs/history";

import Aqp from '../../../libs/mk-react-aqp';

import Pagination from "../../components/Pagination";
import createLink from "../../../libs/createLink";

import {fetchReportingComments} from "../../../creators/reporting.comments";
import {createReportingComment} from "../../../creators/reporting.comment";
import DateSince from "../../components/Date";

import {TextAreaField} from "../../components/FormField";
import {Button} from "../../components/Button";


let mapping = {
    "sort" : "trie"
};


class ReportingComments extends React.Component {
    constructor(props) {
        super(props);

        this.filter = {
            limit: 11,
            page: 1,
            sort: "createdAt"
        };

        this.currentLink = createLink("pcModerator");

        this.aqp = new Aqp(mapping, {
            blacklist: ['limit', 'page'],
            currentLink: `${this.currentLink}/${this.props.reportId}`,
            filterDefault: this.filter
        });

        this.state = {
            filter: {...this.filter, ...this.aqp.query, page: this.props.match.params.page || 1},
            content : ""
        };

        this.handleChangePage = this.handleChangePage.bind(this);

        this.fetchReportingComments(this.state.filter);

    }


    fetchReportingComments(filter){
        this.props.fetchReportingComments(this.props.reportId,this.aqp.set(filter));
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reportingCommentsTotal !== this.props.reportingCommentsTotal && this.props.reportingCommentsInitialized) {
            let totalPage = this.props.reportingCommentsTotal ? Math.ceil(this.props.reportingCommentsTotal / this.state.filter.limit) : 0;
            if(totalPage > this.state.filter.page && this.props.reportingCommentsTotal > prevProps.reportingCommentsTotal){
                this.handleChangePage(totalPage, this.aqp.queryUrl(this.state.filter, mapping).link);
            }
        }
    }

    handleChangePage(page, link) {
        let filter = {...this.state.filter, page};
        if (page === 1) {
            history.push(link);
        } else {
            history.push(link + '/' + page);
        }
        this.setState({filter});
        this.fetchReportingComments(filter);
        window.scrollTo(0, 0);
    }

    handleSubmit() {
        // e.preventDefault();
        if (!this.props.reportingCommentLoading && this.state.content.length >= 1) {
            this.props.createReportingComment(this.props.reportId, {content : this.state.content});
            this.setState({content : ""});
        }
    }


    render() {
        let totalPage = this.props.reportingCommentsTotal ? Math.ceil(this.props.reportingCommentsTotal / this.state.filter.limit) : 0;
        return !this.props.reportingCommentsInitialized ? (<PageLoader />) : (
            <Fragment>
                {this.props.reportingCommentsLoading && (<LoadingBar />)}
                <div className={"reporting-comments"}>
                    {this.props.reportingComments.map((item, index) =>(
                        <div className={`subject w-80 ${(index-1) % 2 ? "content-end" : ""}`} key={item._id}>
                            <div className={"avatar"}>
                                {item.owner && item.owner.profile && item.owner.profile.avatar && (<img src={`${item.owner.profile.avatar}?width=80&height=80`} alt={"avatar"} />)}
                            </div>
                            <div className={"content"}>
                                <div className={"content-header flex-jc-sb"}>
                                    <div >
                                        <a href={createLink("userProfile", item.owner)} target={"new"}>{item.owner && item.owner.username}</a>
                                    </div>
                                    <div className={"text-right"} >
                                        <DateSince date={item.createdAt} />
                                    </div>
                                </div>
                                <div className={"content-body"}>
                                    {item.content}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className={"w-100"}>
                <Pagination currentPage={this.state.filter.page}
                            pagesCount={totalPage}
                            {...this.aqp.queryUrl(this.state.filter, mapping)}
                            handleChangePage={this.handleChangePage}/>
                {this.props.reportingCommentLoading && (<LoadingBar />)}
                </div>
                <div className={"add-comment mt-16"}>
                    <TextAreaField placeholder={"Ajouter un commentaire ..."}
                                   value={this.state.content}
                                   onChange={(event)=>this.setState({content : event.target.value})}/>
                   <div className={"btn-submit"}>
                       <Button onClick={() => this.handleSubmit()}
                               btnStyle={"primary-reverse"}
                               className={"right"}
                               size={"small"}
                               content={"Ajouter"}/>
                   </div>
                </div>
            </Fragment>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        reportingCommentsInitialized: state.reportingComments.initialized,
        reportingCommentsLoading: state.reportingComments.loading,
        reportingComments: state.reportingComments.data,
        reportingCommentsTotal: state.reportingComments.total,

        reportingCommentInitialized: state.reportingComment.initialized,
        reportingCommentLoading: state.reportingComment.loading,
        reportingComment: state.reportingComment.data,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchReportingComments,
    createReportingComment
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReportingComments);
